import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Gear18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_579)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 5.25C6.92893 5.25 5.25 6.92893 5.25 9C5.25 11.0711 6.92893 12.75 9 12.75C11.0711 12.75 12.75 11.0711 12.75 9C12.75 6.92893 11.0711 5.25 9 5.25ZM6.75 9C6.75 7.75736 7.75736 6.75 9 6.75C10.2426 6.75 11.25 7.75736 11.25 9C11.25 10.2426 10.2426 11.25 9 11.25C7.75736 11.25 6.75 10.2426 6.75 9Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.2705 1C11.2705 0.447715 10.8228 0 10.2705 0H7.72974C7.17746 0 6.72974 0.447715 6.72974 0.999999V1.65428C6.72974 3.19042 5.06982 4.1531 3.7365 3.39021L3.13171 3.04417C2.65499 2.77141 2.0475 2.93418 1.77103 3.40876L0.50745 5.57769C0.227902 6.05754 0.392878 6.67325 0.874891 6.94904L1.42542 7.26404C2.76775 8.03208 2.76775 9.96786 1.42541 10.7359L0.874886 11.0509C0.392873 11.3267 0.227899 11.9424 0.507446 12.4222L1.77102 14.5912C2.0475 15.0658 2.65499 15.2285 3.13171 14.9558L3.7365 14.6097C5.06981 13.8468 6.72974 14.8095 6.72974 16.3457V17C6.72974 17.5523 7.17746 18 7.72974 18H10.2705C10.8228 18 11.2705 17.5523 11.2705 17V16.3457C11.2705 14.8095 12.9304 13.8468 14.2637 14.6097L14.8685 14.9558C15.3452 15.2285 15.9527 15.0658 16.2292 14.5912L17.4928 12.4222C17.7723 11.9424 17.6074 11.3267 17.1253 11.0509L16.5748 10.7359C15.2325 9.96786 15.2325 8.03208 16.5748 7.26404L17.1253 6.94904C17.6074 6.67325 17.7723 6.05754 17.4928 5.57769L16.2292 3.40876C15.9527 2.93418 15.3452 2.77141 14.8685 3.04417L14.2637 3.39021C12.9304 4.1531 11.2705 3.19042 11.2705 1.65428V1ZM8.22974 1.65428V1.5H9.77049V1.65428C9.77049 4.34253 12.6754 6.02721 15.0087 4.69216L15.1828 4.5925L15.943 5.89735L15.8299 5.96209C13.4808 7.30616 13.4808 10.6938 15.8299 12.0379L15.943 12.1026L15.1829 13.4074L15.0087 13.3078C12.6754 11.9727 9.77049 13.6574 9.77049 16.3457V16.5H8.22974V16.3457C8.22974 13.6574 5.32487 11.9727 2.99156 13.3078L2.81738 13.4074L2.0572 12.1026L2.17035 12.0379C4.51944 10.6938 4.51944 7.30617 2.17035 5.96209L2.05721 5.89735L2.81738 4.5925L2.99156 4.69216C5.32487 6.02721 8.22974 4.34252 8.22974 1.65428Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_579'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Gear18.displayName = 'Gear18';
export default Gear18;
